import React from "react";

const Loader = ({ size = 40, color = "#ff0000ff" }) => {
    return (
        <div className="loading">
            <div
                className="lds-dual-ring"
                style={{
                    width: size,
                    height: size,
                    borderColor: `${color} transparent ${color} transparent`,
                }}
            ></div>
        </div>
    );
};

export default Loader;
